const NUMBER_OF_RECOMMENDATIONS_TO_FETCH = 10;
const DEFAULT_NUMBER_OF_RECS_TO_SHOW = 5;

export { NUMBER_OF_RECOMMENDATIONS_TO_FETCH, DEFAULT_NUMBER_OF_RECS_TO_SHOW };
